import { Lock } from "@lazarentertainment/web-design-system/components/iconOutline"
import { Button } from "client/designSystem/Button"
import { FormattedMessage } from "react-intl"
import ResponsiveLoader from "shared/components/ResponsiveLoader"

import { DiscountCodeNotice } from "../DiscountCodeNotice"
import { ShopifyProductCartTile } from "../product/ShopifyProductCartTile"
import { useShopContext } from "../ShopContext"
import { PriceText } from "../ui/priceComponents/Price"
import { OuterWrapper } from "../ui/styles/Containers"

import { useCartContext } from "./CartContext"

import styles from "./Cart.module.css"

function Cart() {
  const { shop } = useShopContext()
  const { cart, onCheckoutClick } = useCartContext()

  const lineItems = cart?.lines.nodes ?? []
  const isCartEmpty = !lineItems.length
  const discountCode = shop?.activeSale?.discountCode

  if (!cart) {
    return <ResponsiveLoader />
  }

  const checkoutReady = cart && cart.totalQuantity > 0

  return (
    <OuterWrapper>
      <div className={styles.cart}>
        {isCartEmpty ? (
          <div className={styles.cartEmptyNotice}>
            <h3 className="title-md text-color-primary">
              <FormattedMessage
                id="cart.emptyHeader"
                defaultMessage="Nothing to see here"
              />
            </h3>
            <p className="body-md text-color-secondary">
              <FormattedMessage
                id="cart.emptyText"
                defaultMessage="Your cart is empty."
              />
            </p>
            <p className="body-md text-color-secondary">
              <FormattedMessage
                id="cart.emptyText"
                defaultMessage="Add items to your cart and check out."
              />
            </p>
          </div>
        ) : (
          <div className={styles.cartItemList}>
            {discountCode && <DiscountCodeNotice code={discountCode} />}
            {lineItems.map((lineItem) => {
              return lineItem.merchandise.availableForSale ? (
                <ShopifyProductCartTile
                  key={lineItem.id}
                  lineItem={lineItem}
                />
              ) : null
            })}
          </div>
        )}
      </div>
      <div className={styles.cartCheckOutButtonContainer}>
        <Button
          variant="primary"
          disabled={!checkoutReady}
          type="button"
          icon={Lock}
          onClick={onCheckoutClick}
          data-full-width
          data-robot="cart-check-out"
        >
          {checkoutReady ? (
            <>
              <FormattedMessage
                id="rozy.checkoutWithPriceA"
                defaultMessage="Check Out ("
              />
              <PriceText
                amount={cart.cost.subtotalAmount.amount.toString()}
                currencyCode={cart.cost.subtotalAmount.currencyCode}
              />
              <FormattedMessage
                id="rozy.checkoutWithPriceB"
                defaultMessage=")"
              />
            </>
          ) : (
            <FormattedMessage
              id="rozy.checkout"
              defaultMessage="Check Out"
            />
          )}
        </Button>
      </div>
    </OuterWrapper>
  )
}

export default Cart
